module.exports = __webpack_public_path__ + "static/media/aaa.907b87af.jpg";